import { makeStyles } from '@material-ui/core';
import petmojiUrl from '../../assets/fn-petmoji.png';

/*
 * Collapsed sidebar mark. The horizontal FN-MZ lockup is unreadable at 72px, so
 * the Petmoji stands in for it. Painted through an alpha mask for the same
 * reason as LogoFull - one asset, correct colour in both themes.
 */
const useStyles = makeStyles(theme => ({
  icon: {
    width: 30,
    height: 28,
    backgroundColor: theme.palette.navigation.selectedColor,
    maskImage: `url(${petmojiUrl})`,
    maskRepeat: 'no-repeat',
    maskPosition: 'center',
    maskSize: 'contain',
    WebkitMaskImage: `url(${petmojiUrl})`,
    WebkitMaskRepeat: 'no-repeat',
    WebkitMaskPosition: 'center',
    WebkitMaskSize: 'contain',
  },
}));

export const LogoIcon = () => {
  const classes = useStyles();

  return (
    <div
      className={classes.icon}
      role="img"
      aria-label="Fressnapf | maxi zoo"
    />
  );
};
